import { ApiHelper } from '../../common/helpers/ApiHelper';
import { AppHelper } from '../../helpers/AppHelper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { invFields } from '../../Data/FormFields';
import { Helper } from '../../common/helpers/Helper';

export class InventoryOfOrg extends BaseEntityPage {

  constructor(props) {
    super(props)
    this.orgId = this.props.match.params.id;
    this.pageTitle = 'Inventories'
    this.breadCrumbs = [
      { title: 'Home', to: '/admin' },
      { title: 'Orgs', to: '/admin/orgs/' },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['invs'], { orgId: this.orgId }) },
    ]
    this.tableHeaders = [
      'Title',
      'Brand',
      'Type',
    ]
    this.apiData = {
      orgId: this.orgId,
    }
    this.noAdd = false
  }

  onFetchSuccess(results) {
    this.formDefinition = invFields.fieldDef
    this.setState({
      items: results[0].items
    })
  }

  onAdd() {
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath(['invs']),
    });
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'DELETE',
      apiEndPoint: ApiHelper.makeUrlPath(['invs', current.id]),
    });
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['invs', current.id]),
    });
  }

  onActions(current) {
    const actions = []
    actions.push(AppHelper.buttonEdit(this, current))
    actions.push(AppHelper.buttonDelete(this, current))
    return actions
  }

  onTableValue(current, index) {
    switch (index) {
    case 0:
      return current.title
    case 1:
      return current.brand
    case 2:
      return current.itype
    default:
      return ''
    }
  }

}


// WEBPACK FOOTER //
// ./src/screens/admin/InventoryOfOrg.js